import { useApi } from '@/shared/api/http';

export const useDiscountsService = () => {
  const api = useApi();

  const checkPromoCode = async (promoCode: any, isAuth = true) => {
    try {
      return await api.post<any>('/discounts/promocode/check/', isAuth, promoCode);
    } catch (error) {
      console.error('Ошибка при проверке промокода:', error);
      throw error;
    }
  };

  return {
    checkPromoCode,
  };
};
